
import { nanoid } from '@reduxjs/toolkit'

import { store , allcalendarevents , seteventtochange , defineCalendar} from "../state/redux";
import { addEltHistory } from '../state/reactquery';
import { queryClient } from '../state/queryClient';


import { modifyonelead } from './actions_lead';
import { add15minutes , formatlongdatetime } from './utils_dates';
import { progressions_contact , progressions_devisenvoye, progressions_attentedocuments ,
         progressions_attentesignature } from './listeprogression';
import {  axios_calendar_recordrdv , axios_calendar_updaterdv , axios_calendar_geteventsbyclientid ,
         axios_calendar_getrdvs} from '../axios/axios_calendar';   
import { axios_googleapis_sentevent,axios_googleapis_updateevent , axios_googleapis_geteventsbyclientid ,
        axios_googleapis_getevents , axios_googleapis_deleteevent } from '../axios/axios_googleapis';  
    

import { axios_calendar_deleteevent } from '../axios/axios_calendar';


export const orderevents= (listevents)=>{

    let jsonlistejours = {};  let jsonlistejoursorder ={};
    const listeventsorder = [...listevents].sort((a,b)=> (new Date(a.startDatetime)).getTime() - (new Date(b.startDatetime)).getTime()  );
    for(let i=0; i< listeventsorder.length ; i++){
            if(jsonlistejours.hasOwnProperty((listeventsorder[i].startDatetime).split("T")[0])){
            jsonlistejours[(listeventsorder[i].startDatetime).split("T")[0]] = [...jsonlistejours[(listeventsorder[i].startDatetime).split("T")[0]] ,listeventsorder[i]]
            }else{
            jsonlistejours[(listeventsorder[i].startDatetime).split("T")[0]] =[listeventsorder[i]]
            }
    }
    (Object.keys(jsonlistejours).sort((a,b)=>new Date(new Date(a) - new Date(b) ))).forEach(date=>jsonlistejoursorder[date] = jsonlistejours[date]);
     return {...jsonlistejoursorder}
  }


export const rdvcalendarMemo = async(date,note)=>{   
    const lead = store.getState().lead.leadactu;

    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
    const isGoogleCalendar = localStorage.getItem('calendar')==='google' && user['calendar']==='google' ;

    const summary = 'RdvMutuello '+(lead.nom  && lead.prenom )? lead.nom  +' '+ lead.prenom : lead.nom ? lead.nom:  lead.prenom ? lead.prenom: lead.email? lead.email : 'Inconnu....'
    const description = note +'#ID'+lead.id+'#ID';
    let data = {summary,description,startDatetime: date ,endDatetime:add15minutes(date),email:user['email']} ;

    let reqevent =  !isGoogleCalendar ? await axios_calendar_geteventsbyclientid({email:user['email'], id:lead.id}):
                                        await axios_googleapis_geteventsbyclientid({email:user['email'], id:lead.id}) ;


    const id_event =  reqevent.data?.length>0?  reqevent.data[0]['id'] : undefined ; 

    console.log('=================ERIC===================') ;
    console.log('isGoogleCalendar',isGoogleCalendar) ;
    console.log('reqevent',reqevent,reqevent.data?.length) ;
    console.log('reqevent.data[0][id]',reqevent?.data,reqevent?.data[0],reqevent?.data[0]?.['id']) ;
    console.log('id_event',id_event) ;
    console.log('=======================================') ;
    const id = !isGoogleCalendar?(id_event ?id_event :nanoid()): id_event ;
    const reqrecordupdaterdv = (!isGoogleCalendar && id_event) ?await  axios_calendar_updaterdv({...data,'id':id })  : 
                               (!isGoogleCalendar && !id_event) ? await axios_calendar_recordrdv({...data,'id':id })   :
                                id_event ?  await axios_googleapis_updateevent({...data,'id':id })   :
                                            await axios_googleapis_sentevent({...data,'id':id })  ;
                                            
    insertupdatedevent(reqrecordupdaterdv.data)  ;   
    store.dispatch(seteventtochange(reqrecordupdaterdv.data))  ;

}


export const rdvcalendar = async(date,note)=>{   
    console.log("NOUVO  RDV A ENREGISTRER") ;
    const lead = store.getState().lead.leadactu;

    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
    const isGoogleCalendar = localStorage.getItem('calendar')==='google' && user['calendar']==='google' ;

    const summary = 'RdvMutuello '+(lead.nom  && lead.prenom )? lead.nom  +' '+ lead.prenom : lead.nom ? lead.nom:  lead.prenom ? lead.prenom: lead.email? lead.email : 'Inconnu....'
    const description = note +'#ID'+lead.id+'#ID';
    let data = {summary,description,startDatetime: date ,endDatetime:add15minutes(date),email:user['email']} ;

    let reqrecordupdaterdv ={} ;
    let listeideventsids = [] ;
    if(isGoogleCalendar){ let reqevent =await axios_googleapis_geteventsbyclientid({email:user['email'], id:lead.id}) ;
                            console.log("REQ EVENT GOOGLE CALENDAR",reqevent.data) ;
                        if (reqevent.data?.length > 0) {
                            console.log("EXISTING EVENTS TO DELETE IN GOOGLE CALENDAR") ;
                            const deletePromises = reqevent.data.map(async (ev) => {
                                console.log("DELETION EVENT GOOGLE CALENDAR", ev.id) ;
                                return axios_googleapis_deleteevent({id: ev.id, email: user['email']});
                            });
                            await Promise.all(deletePromises);
                        }     
                        console.log('JESUISSORTIDUIF')                    
                         listeideventsids = reqevent.data?.length>0 ? reqevent.data.map(x=>x.id) : [] ;
                         reqrecordupdaterdv = await axios_googleapis_sentevent({...data,'id': nanoid() }) ;
                         const listcalendarevents =   store.getState().calendar.listcalendarevents; 
                         const othersevents = listcalendarevents.filter(x=>!listeideventsids.includes(x.id)) ;
                         store.dispatch(allcalendarevents([...othersevents, { ...reqrecordupdaterdv.data , 'startDatetime': reqrecordupdaterdv.data?.start?.dateTime}]))  ;
    }else{  let reqevent =   await axios_calendar_geteventsbyclientid({email:user['email'], id:lead.id}) ;
            reqevent.data?.length>0 && reqevent.data.forEach(async(ev)=>{ await axios_calendar_deleteevent(ev.id)}) ;
            listeideventsids = reqevent.data?.length>0 ? reqevent.data.map(x=>x.id) : [] ;
            reqrecordupdaterdv =await axios_calendar_recordrdv({...data,'id':nanoid() }) ;
            const listcalendarevents =   store.getState().calendar.listcalendarevents; 
            const othersevents = listcalendarevents.filter(x=>!listeideventsids.includes(x.id)) ;
            store.dispatch(allcalendarevents([...othersevents, { ...reqrecordupdaterdv.data , 'startDatetime': reqrecordupdaterdv.data?.startDatetime}]))  ;
    }
}


export const insertupdatedevent = (evenement)=>{
    (!evenement?.startDatetime  && evenement?.start?.dateTime) && (evenement['startDatetime'] = evenement?.start?.dateTime ) ;
    const listcalendarevents =   store.getState().calendar.listcalendarevents; 
    const othersevents = listcalendarevents.filter(x=>x.id!==evenement.id) ;
    store.dispatch(allcalendarevents([...othersevents, evenement]))
}

export const deleterdvgooglecalendar= (id)=>{
    const listcalendarevents =   store.getState().calendar.listcalendarevents; 
    const othersevents = listcalendarevents.filter(x=>x.id!==id);
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]); 
   store.dispatch(allcalendarevents([...othersevents])) ;
   axios_googleapis_deleteevent({id ,email:user['email']})

}

export const searchrdvleadgooglecalendar= async(id_lead)=>{   

    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]); 
    const isGoogleCalendar = localStorage.getItem('calendar')==='google' && user['calendar']==='google' ;
    let testregexid =  new RegExp(id_lead, 'g');
    const listcalendarevents =   store.getState().calendar.listcalendarevents; 
    const rdvclient = listcalendarevents.filter(x=>x.description? x.description.match(testregexid)?x.description.match(testregexid)[0] :undefined  :undefined  ) ;
    if(rdvclient.length>0){ return rdvclient[0]}

    let reqevent =  !isGoogleCalendar ? await axios_calendar_geteventsbyclientid({email:user['email'], id:id_lead}):
                                        await axios_googleapis_geteventsbyclientid({email:user['email'], id:id_lead}) ;
    
    return  reqevent?.data?.length>0?   reqevent?.data[0]:{}    
}

export const rdvfromcalendar = (eventtocalendar)=>{
    const lead = store.getState().lead.leadactu;
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]); 
    const displaymodalcalendar = store.getState().display.displaymodalcalendar;
    
    const newstatut = lead.statut_client?.includes('gagne')? lead.statut_client:
                        displaymodalcalendar ==='mod_calendarelance'?( progressions_contact.includes(lead.statut_client)?'contact_relance':progressions_devisenvoye.includes(lead.statut_client)?'devisenvoye_relance':
                                                                progressions_attentedocuments.includes(lead.statut_client)?'attente_documents_relance':progressions_attentesignature.includes(lead.statut_client)?'attente_signature_relance':'contact_relance'):
                                                            ( progressions_contact.includes(lead.statut_client)?'contact_rdv':progressions_devisenvoye.includes(lead.statut_client)?'devisenvoye_rdv':
                                                                progressions_attentedocuments.includes(lead.statut_client)?'attente_documents_rdv':progressions_attentesignature.includes(lead.statut_client)?'attente_signature_rdv':'contact_rdv');  
  
    const champslead = {'date_rdvrelance': eventtocalendar.startDatetime,'statut_client':newstatut, commercial : user['nom']  }


    displaymodalcalendar ==='mod_calendarelance'?addEltHistory(lead.id,'relancefixe',`<div class='horoline1' >Relance fixée ${formatlongdatetime(eventtocalendar.startDatetime)}</div>` ):
                                                addEltHistory(lead.id,'rdvfixe',`<div class='horoline1' >RDV fixé ${formatlongdatetime(eventtocalendar.startDatetime)}</div>` ) ;

    modifyonelead(champslead);
    rdvcalendar(eventtocalendar.startDatetime,eventtocalendar.note)
}


export const getallevents = (navigate) => async () => {

    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]); 

    const responsegetrdv = (user['calendar']!=='google') ? await axios_calendar_getrdvs(user['email']):
                                                           await axios_googleapis_getevents(user['email']);
                                                          
                                                          
    if(responsegetrdv.data.error==='errorauth'){   console.log('VERSLOGIN3') ;
        navigate('/login');store.dispatch(allcalendarevents([])); return  
     }   

    store.dispatch(allcalendarevents([...responsegetrdv.data])) ;
    user['email']  && store.dispatch(defineCalendar(false)) ; 
};



  
  

